import React from "react";

const Files = () => {
  const files = [
    {
      name: "Roosevelt Rd 10 Floor Plan",
      size: "PDF (887.83 KB)",
      link: "/media/files/Roosevelt Rd 10 Floor Plan.pdf",
    },
    {
      name: "10 Roosevelt Brochure",
      size: "PDF (9.72 MB)",
      link: "/media/files/10 Roosevelt Brochure.pdf",
    },
  ];

  return (
    <section
      id="files"
      style={{
        padding: "3rem 1.5rem",
        backgroundColor: "#f9fafb",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "2.5rem",
          fontSize: "2rem",
          fontWeight: "600",
          color: "#222",
        }}
      >
        Property Documents
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2rem",
          flexWrap: "wrap",
        }}
      >
        {files.map((file, index) => (
          <a
            key={index}
            href={file.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                width: "260px",
                background: "#fff",
                borderRadius: "12px",
                padding: "1.5rem",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0,0,0,0.08)";
              }}
            >
              <div
                style={{
                  fontSize: "2.5rem",
                  marginBottom: "1rem",
                  textAlign: "center",
                }}
              >
                📄
              </div>

              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#333",
                  textAlign: "center",
                  marginBottom: "0.5rem",
                }}
              >
                {file.name}
              </h3>

              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#777",
                  textAlign: "center",
                }}
              >
                {file.size}
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Files;